import React from 'react';
import * as mobxReact from 'mobx-react';
import { CommonPopupBodyFooterLayout } from '../../../../../global/common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../../../../global/sub-window/common/common-close-sub-window-buttons';
import { AttendeeBulkUpdateFormViewModel } from './attendee-bulk-update-form.viewmodel';
import { AttendeeBulkUpdateFormBodyPresentation } from './attendee-bulk-update-form-body-presentation';
import { applyText, cancelText } from '../../../../../../constants/common-labels.constants';
import './../attendee-form.scss';

const AttendeeBulkUpdateFormPresentation = mobxReact.observer((props: { vm: AttendeeBulkUpdateFormViewModel }) => {
    const formVM = props.vm;

    return (
        <CommonPopupBodyFooterLayout
            body={<AttendeeBulkUpdateFormBodyPresentation
                formVM={formVM}
            />}
            footer={
                <>
                    <div className='buttons-block buttons-block--from-right'>
                        <DefaultCloseSubWindowButton
                            text={applyText()}
                            modifier={['fat', 'confirm-safe']}
                            onClick={() => formVM.bulkUpdateAttendeeApiCall()}
                        />
                        <DefaultCloseSubWindowButton
                            text={cancelText()}
                        />
                    </div>
                </>
            }
        />
    );
});

export { AttendeeBulkUpdateFormPresentation };
